import { UrlHelper } from 'hoc/UrlHelper';
import React, { useMemo } from 'react';
import findCloudinaryId from 'utils/findCloudinaryId';
import FeatureCard from '~/reusable-components/cards/FeatureCard';
import CarouselWithButtons from '~/reusable-components/carousels/CarouselWithButtons';

const CSS = require('./CityCarousel.less');

const FALLBACK_DESTINATION_IMAGE = 'e81aed073b6325f5de7d7bf9b363e390';

type CityCarouselProps = {
  destinations: {
    country: string;
    area: string;
    city: string;
    image: string;
    nrOfHosts: number;
    nrOfExperiences: number;
  }[];
  ignoreFilters?: boolean;
};

const getTargetUrl = (country: string, area: string) => {
  return UrlHelper.getLocationSearchUrl(country, area);
};

const CityCarousel = ({
  destinations = [],
  ignoreFilters,
}: CityCarouselProps) => {
  const destinationList = useMemo(() => {
    return destinations
      .sort((a, b) =>
        a.nrOfExperiences + a.nrOfHosts > b.nrOfExperiences + b.nrOfHosts
          ? -1
          : 1,
      )
      .map((destination) => ({
        cloudindaryId: destination?.image
          ? findCloudinaryId(destination.image)
          : FALLBACK_DESTINATION_IMAGE,
        url: getTargetUrl(destination.country, destination.area),
        ...destination,
      }));
  }, [destinations]);

  return (
    <CarouselWithButtons className={CSS.CityCarousel}>
      {destinationList.map(({ area, nrOfExperiences, cloudindaryId, url }) => (
        <FeatureCard
          key={url}
          href={url}
          title={area}
          subtitle="Enjoy our"
          cloudinaryId={cloudindaryId}
          alt={`Picture of ${area}`}
          label={`${nrOfExperiences} experiences`}
        />
      ))}
    </CarouselWithButtons>
  );
};

export default CityCarousel;
